export default function NetworkStatus(_props) {
  return null;
}
